export const MsgLuckyBoxPreviewContent = memo(function MsgLuckyBoxPreviewContent() {
  const { t } = useTranslation();
  return `[${t('chat.luckyBoxText')}]`;
});
